var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59961 4.05003C8.59961 3.47012 9.06973 3 9.64964 3H15.9499C16.5298 3 16.9999 3.47012 16.9999 4.05003V8.25017C16.9999 8.83009 16.5298 9.30021 15.9499 9.30021H15.2745V10.6996C15.2745 10.8411 15.1892 10.9687 15.0584 11.0229C14.9276 11.0771 14.7771 11.0471 14.677 10.947L13.0302 9.30021H9.64964C9.06973 9.30021 8.59961 8.83009 8.59961 8.25017V4.05003Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7003 11.3993V14.2443C10.7003 14.8242 10.2301 15.2944 9.65022 15.2944H6.94699L5.34508 16.8963C5.24497 16.9964 5.09443 17.0263 4.96365 16.9721C4.83286 16.918 4.74758 16.7903 4.74758 16.6488V15.2944H4.05003C3.47012 15.2944 3 14.8242 3 14.2443V9.99925C3 9.41934 3.47012 8.94922 4.05003 8.94922H6.50011",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.63e9bef7bc7b2b91c779e9c52212a92e.svg";
export { ForwardRef as ReactComponent };